import React from 'react';

const cities = [
  { name: 'Laurel', county: 'PG County', href: '/mobile-notary/laurel' },
  { name: 'College Park', county: 'PG County', href: '/mobile-notary/college-park' },
  { name: 'Beltsville', county: 'PG County', href: '/mobile-notary/college-park' },
  { name: 'Greenbelt', county: 'PG County', href: '/mobile-notary/greenbelt' },
  { name: 'Aspen Hill', county: 'Montgomery', href: '/service-areas/aspen-hill' },
  { name: 'Rockville', county: 'Montgomery', href: '/service-areas/rockville' },
  { name: 'Gaithersburg', county: 'Montgomery', href: '/service-areas/gaithersburg' },
  { name: 'Silver Spring', county: 'Montgomery', href: '/service-areas/silver-spring' }
];

const ServiceArea = () => {
  return (
    <section id="service-area" className="py-24 px-6 bg-cream">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-brass text-xs font-bold tracking-[0.2em] uppercase mb-4 block">
            WHERE WE TRAVEL
          </span>
          <h2 className="font-fraunces text-4xl md:text-5xl text-navy mb-6 leading-tight">
            Based in Laurel.{' '}
            <span className="italic text-brass">Serving the DMV.</span>
          </h2>
          <p className="text-lg text-navy/70">
            We cover Prince George&apos;s, Howard, and Montgomery counties. If
            you&apos;re nearby and don&apos;t see your town listed, ask anyway.
            We probably go there.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {cities.map((city) => (
            <a
              key={city.name}
              href={city.href}
              className={`group p-8 rounded-2xl border transition-all duration-200 hover:bg-navy hover:border-navy active:bg-navy/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brass active:scale-[0.98] ${
                city.featured
                  ? 'bg-cream-light border-line hover:bg-navy hover:border-navy active:bg-navy/90'
                  : 'bg-cream-light border-line hover:bg-navy hover:border-navy active:bg-navy/90'
              }`}
            >
              <h3
                className={`font-bold text-xl mb-1 ${
                  city.featured ? 'text-navy transition-colors duration-200 group-hover:text-cream' : 'text-navy transition-colors duration-200 group-hover:text-cream'
                }`}
              >
                {city.name}
              </h3>
              <p
                className={`text-[10px] font-bold uppercase tracking-widest ${
                  city.featured ? 'text-brass transition-colors duration-200 group-hover:text-brass-light' : 'text-brass transition-colors duration-200 group-hover:text-brass-light'
                }`}
              >
                {city.county}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;